// extracted by mini-css-extract-plugin
module.exports = {"root":"AspectRatioOneToOne_root__VSWrh","inner":"AspectRatioOneToOne_inner__1LQV6"};